import { useCallback, useEffect, useState } from 'react';
import {
  fetchPlatformAgencies,
  getPlatformAgencyId,
} from '../../services/platform/platformAgenciesService';

export function usePlatformAgencies({
  enabled = false,
  token,
  workspaceAgencyId,
  setWorkspaceAgencyId,
} = {}) {
  const [agencies, setAgencies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadAgencies = useCallback(async () => {
    if (!enabled || !token) {
      setAgencies([]);
      setError(null);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const { agencies: nextAgencies } = await fetchPlatformAgencies({ token });
      setAgencies(nextAgencies);
    } catch (err) {
      setAgencies([]);
      setError(
        err?.response?.data?.detail
        || err?.response?.data?.message
        || err?.message
        || 'Failed to load agencies',
      );
    } finally {
      setLoading(false);
    }
  }, [enabled, token]);

  useEffect(() => {
    loadAgencies();
  }, [loadAgencies]);

  useEffect(() => {
    if (!enabled || workspaceAgencyId || agencies.length !== 1) return;
    const onlyAgencyId = getPlatformAgencyId(agencies[0]);
    if (onlyAgencyId) {
      setWorkspaceAgencyId?.(onlyAgencyId);
    }
  }, [enabled, agencies, workspaceAgencyId, setWorkspaceAgencyId]);

  return {
    agencies,
    loading,
    error,
    reload: loadAgencies,
  };
}
